const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === "development") {
    return "http://127.0.0.1:8000/";
  }

  return "https://api.jusstools.com";
};

// Endpoint callers append "/api/..."; normalize the base to avoid requests like
// "//api/..." when a development URL is configured with a trailing slash.
const apiurl = getApiUrl().replace(/\/+$/, "");

export default apiurl;
